import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/utils';

/**
 * Tableボディコンポーネント
 */
type TableBodyProps = ComponentPropsWithRef<'tbody'>;

export const TableBody = ({ className, ref, ...props }: TableBodyProps) => (
  <tbody ref={ref} className={cn(className)} {...props} />
);
